import { Component, Input } from '@angular/core';

import { GridData, CellComponent, CellContext } from '@grid/models';
import { ConfigurationOption, ConfigurationOptionMap } from '@shared/enums';
import { ExtendedDataType } from '@shared/models';
import { TableOfColumnItemWithValues } from '@shared/models/project-setup';
import { isColumnConfigured } from '@shared/utils';

@Component({
  selector: 'app-configuration-badge-display',
  template: `
    <div
      [attr.data-testId]="
        'display-' + context.column.header.name + '-' + context.row.index
      "
      class="no-truncate d-flex"
    >
      <span>
        <a
          class="d-flex font-weight-bold"
          [ngClass]="{ 'href-disabled': context.parameters?.isDisabled }"
        >
          <mat-icon svgIcon="cog" class="mr-1"></mat-icon>
          {{ configurationLabel }}
        </a>
      </span>
    </div>
  `,
})
export class ConfigurationBadgeDisplayComponent
  implements CellComponent<GridData>
{
  @Input({ required: true }) context!: CellContext<GridData>;
  ExtendedDataType = ExtendedDataType;

  protected configurationLabel: string;

  ngOnInit() {
    this.configurationLabel = this.getLocalizedMessage();
  }

  private getLocalizedMessage(): string {
    const dataTypeId = this.context.data?.dataTypeId;

    let options = '';

    switch (dataTypeId) {
      case ExtendedDataType.Boolean:
        options = '2';
        break;
      case ExtendedDataType.List:
        options = this.context.data?.values?.length.toString();
        break;
      case ExtendedDataType.Number:
      case ExtendedDataType.Percentage:
      case ExtendedDataType.Formula:
        options = ConfigurationOptionMap.get(
          isColumnConfigured(this.context.data as TableOfColumnItemWithValues)
            ? ConfigurationOption.On
            : ConfigurationOption.Off
        );
        break;
      default:
        break;
    }

    return $localize`:@@shared.grid.display.listValuesBadgeDisplay.lblConfigurationFieldValue:Configure (${options}:configurationOptions:)`;
  }
}
